import { ReactComponent as Dashboard } from "../../assets/icon/dashboard.svg";
import { ReactComponent as CreateNew } from "../../assets/icon/plus-add-document-create-page-svgrepo-com.svg";
import { ReactComponent as AllList } from "../../assets/icon/group-svgrepo-com.svg";
import { ReactComponent as Renewal } from "../../assets/icon/renewal.svg";
import { ReactComponent as ClientICon } from "../../assets/icon/customer.svg";
import { ReactComponent as Edit } from "../../assets/icon/edit.svg";
import { ReactComponent as View } from "../../assets/icon/view.svg";
import { ReactComponent as GroupIcon } from "../../assets/icon/group.svg";
import { ReactComponent as documentsIcon } from "../../assets/icon/document.svg";



import { ReactComponent as Logout } from "../../assets/images/logout.svg";

export const ICON_MAP = {
    dashboard: Dashboard,
    createNew: CreateNew,
    list: AllList,
    renewal: Renewal,
    clientICon: ClientICon,
    logout: Logout,
    edit: Edit,
    view: View,
    groupIcon:
        GroupIcon,
    documentsIcon:
        documentsIcon,
};
